import { useEffect } from 'react'
import { useParams } from '@tanstack/react-router'
import { Header } from 'components/layout/header'
import { Main } from 'components/layout/main'
import { Search } from 'components/search'
import {
  showMembershipCode,
  updateMembershipCode,
} from 'store/membershipCodes/membershipCodesSlice'
import { useAppDispatch, useAppSelector } from 'store/store'
import { EditMembershipCodesForm } from 'ui/components/EditMembershipCodesForm'

export const EditMembershipCodesPage = () => {
  const dispatch = useAppDispatch()
  const { membershipCode } = useAppSelector((state) => state.membershipCodes)

  const { id } = useParams({
    from: '/protected/codici-membership/$id/modifica',
  }) as { id: string }
  useEffect(() => {
    if (id) {
      dispatch(showMembershipCode(Number(id)))
    }
  }, [dispatch, id])

  return (
    <>
      {/* ===== Top Heading ===== */}
      <Header>
        <div className='ml-auto flex items-center space-x-4'>
          <Search />
        </div>
      </Header>

      {/* ===== Main ===== */}
      <Main>
        <div className='mb-2 flex flex-wrap items-center justify-between space-y-2 gap-x-4'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>
              Modifica Codice Membership
            </h2>
            <p className='text-muted-foreground'>
              Pagina di modifica Codice Membership
            </p>
          </div>
        </div>
        <div className='-mx-4 mt-5 flex-1 overflow-auto px-4 py-1 lg:flex-row lg:space-y-0 lg:space-x-12'>
          <EditMembershipCodesForm
            onUpdate={(id, data) =>
              dispatch(updateMembershipCode({ id, data }))
            }
            membershipCode={membershipCode}
          />
        </div>
      </Main>
    </>
  )
}

export default EditMembershipCodesPage
